
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7MaHq", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $8Ksv7 = parcelRequire("8Ksv7");


var $jCoeB = parcelRequire("jCoeB");

const $5591b718940edee5$export$d92a178c6c95211f = (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { contentId: contentId, extensionKey: extensionKey, mode: mode, node: node, spaceKey: spaceKey, appearance: appearance, showTemplateVariablesInPreview: showTemplateVariablesInPreview, showTemplateInputInPreview: showTemplateInputInPreview, Renderer: Renderer, getExtensionHandlers: getExtensionHandlers } = t0;
    let t1;
    if ($[0] !== contentId || $[1] !== extensionKey || $[2] !== mode || $[3] !== node || $[4] !== spaceKey) {
        t1 = (RendererWrapper)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Ksv7.BlogPostsMacroHandler), {
                macroDefaultProps: {
                    contentId: contentId,
                    extensionKey: extensionKey,
                    mode: mode,
                    node: node,
                    spaceKey: spaceKey
                },
                macroParams: node?.parameters?.macroParams,
                RendererWrapper: RendererWrapper
            });
        $[0] = contentId;
        $[1] = extensionKey;
        $[2] = mode;
        $[3] = node;
        $[4] = spaceKey;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== Renderer || $[7] !== appearance || $[8] !== getExtensionHandlers || $[9] !== showTemplateInputInPreview || $[10] !== showTemplateVariablesInPreview || $[11] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jCoeB.NestedAdfSSRRendererWrapperProvider), {
            appearance: appearance,
            Renderer: Renderer,
            getExtensionHandlers: getExtensionHandlers,
            showTemplateInputInPreview: showTemplateInputInPreview,
            showTemplateVariablesInPreview: showTemplateVariablesInPreview
        }, t1);
        $[6] = Renderer;
        $[7] = appearance;
        $[8] = getExtensionHandlers;
        $[9] = showTemplateInputInPreview;
        $[10] = showTemplateVariablesInPreview;
        $[11] = t1;
        $[12] = t2;
    } else t2 = $[12];
    return t2;
};
module.exports["BlogPostsSSRExtensionHandler"] = $5591b718940edee5$export$d92a178c6c95211f;

});

parcelRegister("8Ksv7", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $11414ac1857ca883$export$cfa4ed6e2f4ad26 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "lJE6O",
    name: "BlogPostsMacroHandler",
    loader: async ()=>(await (parcelRequire("3qLbV"))).BlogPostsMacroRenderer
});
module.exports["BlogPostsMacroHandler"] = $11414ac1857ca883$export$cfa4ed6e2f4ad26;

});

parcelRegister("3qLbV", function(module, exports) {

let $27f86809575e2a0b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $27f86809575e2a0b$var$load("g74ox"),
    $27f86809575e2a0b$var$load("iq0gB"),
    $27f86809575e2a0b$var$load("1GCFv"),
    $27f86809575e2a0b$var$load("dZsGY"),
    $27f86809575e2a0b$var$load("bV5bW"),
    $27f86809575e2a0b$var$load("28h7Y")
]).then(()=>parcelRequire('5iRsI'));

});

parcelRegister("ZJvdP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $543e3a9ad9cfc398$export$3ad73c971369d052 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "sYDyD",
    name: "PageIncludeMacroHandler",
    loader: async ()=>(await (parcelRequire("cqkhv"))).PageIncludeMacroRenderer
});
module.exports["PageIncludeMacroHandler"] = $543e3a9ad9cfc398$export$3ad73c971369d052;

});

parcelRegister("cqkhv", function(module, exports) {

let $90b7a532fd6dc45f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $90b7a532fd6dc45f$var$load("5h4De").then(()=>parcelRequire('doY9Y'));

});

parcelRegister("e1Stz", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $36f7db2a9cac59c0$export$7cf7439e5d7797c5 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ymRP0",
    name: "PagePropertiesReportRenderer",
    loader: async ()=>(await (parcelRequire("lxdJ9"))).PagePropertiesReportRenderer
});
module.exports["PagePropertiesReportRenderer"] = $36f7db2a9cac59c0$export$7cf7439e5d7797c5;

});

parcelRegister("lxdJ9", function(module, exports) {

let $fad753fc6d69128c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fad753fc6d69128c$var$load("6uCgj"),
    $fad753fc6d69128c$var$load("khyhL"),
    $fad753fc6d69128c$var$load("YAi2k"),
    $fad753fc6d69128c$var$load("adNrA"),
    $fad753fc6d69128c$var$load("g74ox"),
    $fad753fc6d69128c$var$load("iq0gB"),
    $fad753fc6d69128c$var$load("6wr18"),
    $fad753fc6d69128c$var$load("ffEVr"),
    $fad753fc6d69128c$var$load("hhss7"),
    $fad753fc6d69128c$var$load("dnwTC")
]).then(()=>parcelRequire('3Jp28'));

});


//# sourceMappingURL=BlogPostsSSRExtensionHandler.69bda2e5.js.map
